module.exports = __webpack_public_path__ + "img/sz_img_big2.f6907cda.png";